import { useState, useRef, useEffect } from 'react'

const useIntersection = ({ root = null, rootMargin = '0px', threshold = 1.0 }) => {
  const [entry, setEntry] = useState(true)
  const [node, setNode] = useState(null)

  const observer = useRef(null)

  useEffect(() => {
    if (observer.current) observer.current.disconnect()

    observer.current = new IntersectionObserver(([entry]) => {
      setEntry(entry.isIntersecting)
    }, { root, rootMargin, threshold })

    const { current: currentObserver } = observer

    if (node && currentObserver) currentObserver.observe(node)

    return () => {
      if (currentObserver) currentObserver.disconnect()
    }
  }, [node, root, rootMargin, threshold])

  return [entry, setNode]
}

export default useIntersection
